// extracted by mini-css-extract-plugin
export default {"confirmIcon":"SuccessModalMessage_confirmIcon__8TCxx","confirmContainer":"SuccessModalMessage_confirmContainer__kQzXK"};